import React from 'react';
import { Phone, Mail } from 'lucide-react';
export function StickyCTAs() {
  return <>
      {/* Mobile Sticky Bottom Bar */}
      <div className="md:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 shadow-[0_-4px_6px_-1px_rgba(0,0,0,0.1)] z-50 pb-safe" data-id="element-198">
        <div className="flex p-3 gap-3" data-id="element-199">
          <a href="tel:18007085433" className="flex-1 flex items-center justify-center bg-legal-red text-white py-3 px-4 rounded hover:bg-legal-redHover transition-colors font-semibold text-sm" data-id="element-200">
            <Phone className="w-4 h-4 mr-2" data-id="element-201" />
            Call Now
          </a>
          <a href="11014.html" className="flex-1 flex items-center justify-center bg-legal-dark text-white py-3 px-4 rounded hover:bg-black transition-colors font-semibold text-sm" data-id="element-202">
            <Mail className="w-4 h-4 mr-2" data-id="element-203" />
            Contact Us
          </a>
        </div>
      </div>
    </>;
}